import React, { Component } from "react";
import { connect } from "react-redux";
import { compose } from "recompose";
import { withFirebase } from "../../Firebase";
import { isMobile } from "react-device-detect";
import getInputField from "../customFields/getInputField";
import _ from "lodash";
import Field from "../ControlEngine/Feild";
import moment from "moment";
import { addAudit } from "../audits/addAudits";
import DashColumns from "./StaticList/DashColumns";

import {
  Card,
  CardAreaMain,
  CardContent,
  Button,
  CardActions,
  CardActionsSupplemental,
  CircleProgress
} from "reactackle";

class CreateTable extends Component {
  state = {
    data: {
      path: this.props.path,
      payload: {
        name: "",
        fields: [],
        dashColumns: [],
        searchColumns: [],
        filters: [],
        notifyUsers: [],
        otherFieldsToUpdate: [],
        updateNotifyText: "",
        createNotifyText: "",
        deleteNotifyText: "",
        ...this.props.selectedRecord
      },
      userEmail: this.props.userProfile.userEmail
    },
    showForm: true,
    generatingStatement: false,
    statementLink: ""
  };

  //single method that work for all fields
  //takes incoming id of the field and then adds field data to state
  stateChangeHandler = (val, id, isPayload) => {
    // console.log(
    //   "val: " + JSON.stringify(val) + " id: " + id + " isPayload: " + isPayload
    // );
    let tmpState = {};
    tmpState[id] = val;

    if (isPayload) {
      this.setState(prevState => {
        if (prevState && prevState.data.payload !== null) {
          return {
            ...prevState,
            data: {
              ...prevState.data,
              payload: {
                ...prevState.data.payload,
                ...tmpState
              }
            }
          };
        } else {
          return {
            ...prevState,
            data: {
              path: prevState.data.path,
              payload: {
                ...tmpState
              }
            }
          };
        }
      });
    } else {
      this.setState(prevState => {
        return {
          ...prevState,
          ...tmpState
        };
      });
    }
  };

  saveHandler = newPayload => {
    this.stateChangeHandler(this.props.userEmail, "author", true);
    this.stateChangeHandler(false, "showForm", false);

    let myDate = moment().format("DD-MM-YYYY");

    let cloudPath = "";
    if (
      this.state.data.payload &&
      this.state.data.payload.key &&
      this.state.data.payload.key !== ""
    ) {
      cloudPath = this.props.path + "/" + this.state.data.payload.key;
      Promise.all([
        addAudit(this.stateChangeHandler, this.props.userEmail)
      ]).then(res => {
        // console.log("UPDATE RECORD: " + cloudPath);
        // console.log("Here is the path: " + cloudPath);
        //console.log(JSON.stringify(this.state.data.payload));
        this.props.firebase.db
          .ref("/" + cloudPath)
          .once("value")
          .then(snap => {
            return snap.ref.set(this.state.data.payload);
          })
          .catch(err => {
            console.log(err);
            return "some error: " + err;
          })
          .then(err => this.props.handleEditCancel());
      });
    } else {
      cloudPath = this.props.path;
      Promise.all([
        addAudit(this.stateChangeHandler, this.props.userEmail)
        //get new ID
      ]).then(res => {
        var newInv = this.props.firebase.db.ref("/" + cloudPath).push();
        let tgtObj = {};
        if (newPayload && newPayload !== undefined) {
          tgtObj = newPayload;
        }
        //console.log(JSON.stringify(tgtObj));
        newInv
          .set(tgtObj)
          .catch(err => {
            // console.log(err);
            return "some error: " + err;
          })
          .then(err => this.props.handleEditCancel());
      });
    }

    //this.props.handleEditCancel();
  };

  addToTablesList = () => {
    //path tableList

    let tableName = this.state.data.payload.name;
    let caption = this.state.data.payload.caption;
    let menu = this.state.data.payload.menu;

    let currTableList = _.cloneDeep(this.props.tableList);
    let found = false;
    let foundKey = "";
    let foundObj = {};
    if (currTableList && currTableList.length > 0) {
      for (let i = 0; i < currTableList.length; i++) {
        if (currTableList[i]["name"] === tableName) {
          found = true;
          foundKey = currTableList[i].key;
          foundObj = {
            ...currTableList[i],
            name: tableName,
            caption: caption,
            menu: menu
          };
        }
      }
    }
    let cloudPath = "listOfTables";
    if (!found) {
      var newInv = this.props.firebase.db.ref("/" + cloudPath).push();
      newInv
        .set({
          name: tableName,
          caption: caption,
          menu: menu
        })
        .catch(err => {
          console.log(err);
          return console.log("some error: " + err);
        })
        .then(err => {});
    } else {
      this.props.firebase.db
        .ref("/" + cloudPath + "/" + foundKey)
        .once("value")
        .then(snap => {
          return snap.ref.set(foundObj);
        })
        .catch(err => {
          console.log(err);
          return "some error: " + err;
        })
        .then(err => {});
    }
  };

  publishHandler = () => {
    //this should update
    // A. List of tables? do i really need to update that? Yes ||DONE||
    // C. Dashboard Fields ||ADDED TO FILE||
    // D. Search Fields ||ADDED TO FILE||
    // D. Menu List -> should be its own module
    // E. Roles? No - this should me another module
    //console.log(this.state.data.payload.fullText);
    console.log("publishing now...");
    let newPayload = undefined;
    if (
      this.state.data.payload.fullText &&
      this.state.data.payload.fullText !== ""
    ) {
      newPayload = JSON.parse(this.state.data.payload.fullText);
    }
    if (newPayload && newPayload.tableName && newPayload.tableName !== "") {
      //console.log("going with fullText");
      this.saveHandler(newPayload);
    } else {
      //console.log("going with non fullText");
      Promise.all([
        this.saveHandler(this.state.data.payload),
        this.addToTablesList()
      ]).then(res => {});
    }
    this.props.handleEditCancel();
  };

  getField = (fieldName, disabled) => {
    return getInputField(
      fieldName,
      "createTable",
      this.state.data,
      this.stateChangeHandler,
      disabled,
      this.props.ogTableDef
    );
  };

  addField = () => {
    let currFields = _.cloneDeep(this.state.data.payload.fields);
    currFields.push({
      type: "",
      selectorType: "",
      staticSource: [{ name: "" }],
      isMust: "true",
      enabled: "true",
      colDefs: [
        {
          name: "",
          key: "",
          editable: true,
          resizable: true
        }
      ],
      otherFieldsToUpdate: [{ src: "", tgt: "" }]
    });
    this.stateChangeHandler(currFields, "fields", true);
  };

  itemHandler = (fldName, val, rowNum) => {
    let newArray = _.cloneDeep(this.state.data.payload.fields);
    let currPayload = newArray[rowNum];
    currPayload[fldName] = val;
    this.stateChangeHandler(newArray, "fields", true);
  };

  getFieldsList = () => {
    return this.state.data.payload.fields.map((fieldData, rowNum) => {
      //console.log(JSON.stringify(fieldData));
      return (
        <div>
          <Field
            data={{ payload: fieldData }}
            itemHandler={this.itemHandler}
            rowNum={rowNum}
            itemAddHandler={this.itemAddHandler}
            itemDeleteHandler={this.itemDeleteHandler}
            move={this.move}
            ogTableDef={this.props.ogTableDef}
            tableList={this.props.tableList}
            createTableList={this.props.createTable}
            tgtFieldsList={this.getCurrentTableFields}
            selectedGridFields={this.getGridFields}
          />
        </div>
      );
    });
  };

  getCurrentTableFields = keyField => {
    //console.log("~~~~" + keyField);
    if (
      this.state.data.payload.fields &&
      this.state.data.payload.fields.length > 0
    ) {
      if (keyField && keyField === "name") {
        return this.state.data.payload.fields.map(fld => {
          return { name: fld.name, fieldName: fld.name, fldType: fld.type };
        });
      } else {
        return this.state.data.payload.fields.map(fld => {
          return { name: fld.caption, fieldName: fld.name, fldType: fld.type };
        });
      }
    } else {
      return [];
    }
  };

  getGridFields = gridName => {
    if (
      this.state.data.payload.fields &&
      this.state.data.payload.fields.length > 0
    ) {
      let selectedGrid = this.state.data.payload.fields.find(
        fld => fld.name === gridName
      );
      if (
        selectedGrid &&
        selectedGrid !== undefined &&
        selectedGrid.colDefs &&
        selectedGrid.colDefs.length > 0
      ) {
        return selectedGrid.colDefs.map(item => {
          return { name: item.key, fieldName: item.key };
        });
      } else {
        return [];
      }
    } else {
      return [];
    }
  };

  move = (oldIndex, newIndex) => {
    let array = _.cloneDeep(this.state.data.payload.fields);
    //console.log("before: " + JSON.stringify(array));
    if (newIndex >= array.length) {
      newIndex = array.length - 1;
    }
    array.splice(newIndex, 0, array.splice(oldIndex, 1)[0]);
    //console.log("after: " + JSON.stringify(array));
    this.stateChangeHandler(array, "fields", true);
  };

  itemAddHandler = rowNum => {
    //console.log("fromRow: " + fromRow + " updated: " + JSON.stringify(updated));
    let tmpData = _.cloneDeep(this.state.data.payload.fields);
    //console.log("Before: " + JSON.stringify(tmpData));
    tmpData.splice(rowNum + 1, 0, {
      type: "",
      selectorType: "",
      staticSource: [{ name: "" }],
      colDefs: [
        {
          name: "",
          key: "",
          editable: true,
          resizable: true
        }
      ]
    });

    //console.log("After: " + JSON.stringify(tmpData));
    this.stateChangeHandler(tmpData, "fields", true);
  };

  itemDeleteHandler = rowNum => {
    let tmpData = _.cloneDeep(this.state.data.payload.fields);
    delete tmpData[rowNum];
    tmpData = tmpData.filter(item => item !== null);
    this.stateChangeHandler(tmpData, "fields", true);
  };

  columnsAddHandler = (fieldName, val) => {
    let currDashFields = _.cloneDeep(this.state.data.payload[fieldName]);
    currDashFields.push(val);
    this.stateChangeHandler(currDashFields, fieldName, true);
  };

  dashColumnsAddHandler = (val, id, isPayload) => {
    let currDashFields = _.cloneDeep(this.state.data.payload.dashColumns);
    currDashFields.push(val);
    this.stateChangeHandler(currDashFields, "dashColumns", true);
  };

  searchColumnsAddHandler = (val, id, isPayload) => {
    let currSearchFields = _.cloneDeep(this.state.data.payload.searchColumns);
    currSearchFields.push(val);
    this.stateChangeHandler(currSearchFields, "searchColumns", true);
  };

  getUsersList = () => {
    let newArray = this.props.users.map(item => {
      return {
        name: item.userEmail
      };
    });
    //console.log("~~~~" + JSON.stringify(newArray));
    return newArray;
  };

  getCreateTableForm = () => {
    return (
      <div>
        {this.getField("name", this.props.operationType === "update")}
        {this.getField("caption", false)}
        {this.getField("menu", false)}
        <DashColumns
          fieldsList={this.state.data.payload.fields}
          stateFieldName={"dashColumns"}
          value={this.state.data.payload.dashColumns}
          itemHandler={(val, id, isPayload) =>
            this.columnsAddHandler("dashColumns", val)
          }
          stateChangeHandler={this.stateChangeHandler}
          isPayload={true}
          title={"GRID FIELDS"}
        />
        <DashColumns
          fieldsList={this.state.data.payload.fields}
          stateFieldName={"searchColumns"}
          value={this.state.data.payload.searchColumns}
          itemHandler={(val, id, isPayload) =>
            this.columnsAddHandler("searchColumns", val)
          }
          stateChangeHandler={this.stateChangeHandler}
          isPayload={true}
          title={"SEARCH FIELDS"}
        />
        <DashColumns
          fieldsList={this.state.data.payload.fields}
          stateFieldName={"filters"}
          value={this.state.data.payload.filters}
          itemHandler={(val, id, isPayload) =>
            this.columnsAddHandler("filters", val)
          }
          stateChangeHandler={this.stateChangeHandler}
          isPayload={true}
          title={"FILTERS"}
        />
        <DashColumns
          fieldsList={this.getUsersList()}
          stateFieldName={"notifyUsers"}
          value={this.state.data.payload.notifyUsers}
          itemHandler={(val, id, isPayload) =>
            this.columnsAddHandler("notifyUsers", val)
          }
          stateChangeHandler={this.stateChangeHandler}
          isPayload={true}
          title={"NOTIFICATION RECIPIENTS"}
        />
        {this.getField("createNotifyText", false)}
        {this.getField("updateNotifyText", false)}
        {this.getField("deleteNotifyText", false)}
        <hr />
        <div
          style={{
            padding: "5px",
            marginBottom: "10px",
            marginTop: "-5px",
            border: "0px solid blue"
          }}
        >
          <table>
            <tr>
              <td>
                <Button
                  text="ADD FORM FIELD"
                  onPress={() => this.addField()}
                  colorScheme="primary"
                  disabled={!this.state.showForm}
                />
              </td>
              <td>
                <Button
                  text="EXPAND ALL"
                  onPress={() => {
                    let newFieldsArray = this.state.data.payload.fields.map(
                      fld => {
                        return {
                          ...fld,
                          expanded: true
                        };
                      }
                    );

                    this.stateChangeHandler(newFieldsArray, "fields", true);
                  }}
                  colorScheme="primary"
                  disabled={!this.state.showForm}
                />
              </td>
              <td>
                <Button
                  text="COLLAPSE ALL"
                  onPress={() => {
                    let newFieldsArray = this.state.data.payload.fields.map(
                      fld => {
                        return {
                          ...fld,
                          expanded: false
                        };
                      }
                    );

                    this.stateChangeHandler(newFieldsArray, "fields", true);
                  }}
                  colorScheme="primary"
                  disabled={!this.state.showForm}
                />
              </td>
            </tr>
          </table>
        </div>

        {this.getFieldsList()}
        <hr />
        <div>
          <pre>
            <code>{JSON.stringify(this.state.data.payload, undefined, 2)}</code>
          </pre>
        </div>
        <hr />
        <hr />
        {this.getField("fullText", false)}
      </div>
    );
  };

  getLoader = () => {
    return (
      <CardContent>
        <CircleProgress
          indeterminate
          subtitle="Saving..."
          labelPositionY="bottom"
          labelPositionX="center"
        />
      </CardContent>
    );
  };

  getTopHeader = () => {
    return (
      <div>
        <Card>
          <CardAreaMain>
            {!isMobile && (
              <CardContent>
                <div>
                  <h1>CREATE TABLE</h1>
                </div>
              </CardContent>
            )}
            <CardActions>
              <CardActionsSupplemental>
                {this.props.operationType !== "add" && (
                  <Button
                    text="DELETE"
                    onPress={e => {
                      if (
                        this.state.data.payload.key &&
                        this.state.data.payload.key !== ""
                      ) {
                        window.confirm(
                          "Are you sure you wish to delete this item?"
                        ) &&
                          this.props.handleDelete(
                            this.state.data.payload.key,
                            this.props.path
                          );
                      }
                    }}
                    colorScheme="warning"
                    disabled={!this.state.showForm}
                  />
                )}

                <Button
                  text="PUBLISH"
                  onPress={e => {
                    this.publishHandler();
                  }}
                  colorScheme="primary"
                  disabled={!this.state.showForm}
                />

                <Button
                  text="CANCEL"
                  onPress={() => this.props.handleEditCancel()}
                  colorScheme="primary"
                  disabled={!this.state.showForm}
                />
              </CardActionsSupplemental>
            </CardActions>
          </CardAreaMain>
        </Card>
      </div>
    );
  };

  render() {
    return (
      <div>
        <div>{this.getTopHeader()}</div>

        {isMobile && (
          <div>
            {this.state.showForm && this.getCreateTableForm()}
            {!this.state.showForm && this.getLoader()}
          </div>
        )}
        {!isMobile && (
          <Card>
            <CardAreaMain style={{ padding: "0px" }}>
              <CardContent style={{ pading: "0px" }}>
                {this.state.showForm && this.getCreateTableForm()}
                {!this.state.showForm && this.getLoader()}
              </CardContent>
            </CardAreaMain>
          </Card>
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    userEmail: state.db.currentUser.userEmail,
    currUser: state.db.currentUser,
    isSuperAdmin: state.ui.isThisSuperAdmin,
    isAdmin: state.ui.isThisAdmin,
    userProfile: state.db.userProfile,
    selectedRecord: state.db["selected" + state.ui.tableName],
    users: state.db.users,
    projects: state.db.projects,
    contacts: state.db.contacts,
    suppliers: state.db.suppliers,
    poId: state.db.poId,
    operationType: state.ui.operationType,
    tableList: state.db.listOfTables === undefined ? [] : state.db.listOfTables,
    createTable: state.db.createTable
  };
}

const mapDispatchToProps = dispatch => {
  return {
    onGetId: data => dispatch(getId(data)),
    onGetPoStatement: data => dispatch(getStatement(62673, data))
  };
};

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withFirebase
)(CreateTable);



// WEBPACK FOOTER //
// ./src/app/components/Screens/ControlEngine/CreateTable.jsx